module.exports = __webpack_public_path__ + "img/VL_10_02.1e94b8ec.png";